import AnalyticsConstants from '../../../analytics/constants';
import { createAndSendPageLoadEvent } from '../../../analytics/commonAnalytics';

const pageName = AnalyticsConstants.PageNames.IQMyEstimates;
const pageType = AnalyticsConstants.PageTypes.InterconnectedQuotes;
const primaryCategory = AnalyticsConstants.PrimaryCategories.InterconnectedQuotes;
const subCategory1 = AnalyticsConstants.PageNames.IQMyEstimates;
const subCategory2 = AnalyticsConstants.PageNames.IQMyEstimates;

export default () => {
  createAndSendPageLoadEvent(
    window.globalConfig.siteId,
    pageName,
    pageType,
    primaryCategory,
    subCategory1,
    subCategory2,
  );
};
